module.exports = __webpack_public_path__ + "static/media/Line 3.79c546e1.png";